export default class TableResponsive {
    constructor() {
        this.classToFind = '.table-bordered, .table-content';
        this.wrapperClass = 'table-responsive';
    }

    init() {
        let context = this;

        document.addEventListener('DOMContentLoaded', () => {
            let tables = $(context.classToFind);

            for (let i = 0; i < tables.length; i++) {
                if (context.hasWrapper(tables[i].parentNode)) {
                    continue;
                }

                context.wrapTable(tables[i]);
            }
        });
    }

    hasWrapper(node) {
        let isDiv = node.nodeName === 'DIV',
            hasWrapperClass = node.classList.contains(this.wrapperClass);

        return isDiv && hasWrapperClass;
    }

    createWrapper() {
        let wrapper = document.createElement('div');
        wrapper.classList.add(this.wrapperClass);

        return wrapper;
    }

    wrapTable(table) {
        let wrapper = this.createWrapper();

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    }
}
